<template>
  <v-row class="page-breadcrumb">
    <v-col cols="12" sm="12" class="pt-0">
      <v-toolbar density="compact" flat color="transparent" class="mb-1" height="40">
        <v-toolbar-title>
          <span class="text-info">{{ $t(title) }}</span>
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
  </v-row>
</template>
<script>

export default {
  name: "AdpBreadcrumb",
  props: {
    title: String,
  },
  data: () => ({}),
};
</script>
<style lang="scss">
.page-breadcrumb {
  padding-top: 8px;
  padding-bottom: 8px;
  .v-toolbar {
    background-color: transparent !important;
  }
  .v-toolbar__content {
    padding: 0px;
  }
}
</style>
